import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { IProduct } from "@pbm/products/contracts/product";
import { usePbm2Url } from "@common/hooks";

export function useProduct(ean: string) {
  const { request } = usePbm2Url();
  return useQuery(`product:${ean}`, async () => {
    const {
      Rules_products: { edges },
    } = await request(
      gql`
        query ($ean: ID!) {
          Rules_products(first: 1, filter: { ean: [$ean] }) {
            edges {
              cursor
              node {
                id
                ean
                name
                brand
                package
                createdAt
                updatedAt
                contentQuantity
                contentType
                industryName
              }
            }
          }
        }
      `,
      { ean }
    );
    const products = (edges || []).map(
      ({ node }: { node: IProduct }) => node
    ) as IProduct[];

    return products.shift();
  });
}
